import React from "react";
import { Link } from "react-router-dom";

/**
 * Legal footer with Privacy Policy + Terms of Service + Universal test phone hint.
 *
 * Renders on login pages and the customer profile page so App Store / Play Store
 * reviewers (and curious users) can find the legal docs without an account.
 *
 * The "Demo login" hint is shown ONLY when `showTestHint` is true — useful on
 * login screens for reviewers, but hidden on profile pages where it would
 * leak credentials to real users.
 */
export default function LegalFooter({ showTestHint = false, theme = "dark" }) {
  const muted = theme === "dark" ? "text-white/50" : "text-neutral-500";
  const link = theme === "dark" ? "text-white/80 hover:text-white" : "text-brand-sky hover:underline";

  return (
    <footer className={`px-4 py-6 text-center text-xs ${muted}`} data-testid="legal-footer">
      {showTestHint && (
        <div className="mb-3 inline-block px-3 py-1.5 rounded-md bg-white/10 text-[11px]" data-testid="legal-footer-test-hint">
          <span className="font-semibold">Reviewer Demo:</span>{" "}
          phone <span className="font-mono">9898989898</span> · OTP <span className="font-mono">123456</span>
        </div>
      )}
      <div className="flex items-center justify-center gap-4">
        <Link to="/legal/privacy" className={link} data-testid="legal-footer-privacy">
          Privacy Policy
        </Link>
        <span className="opacity-30">·</span>
        <Link to="/legal/terms" className={link} data-testid="legal-footer-terms">
          Terms of Service
        </Link>
      </div>
    </footer>
  );
}
